import { Component, Injectable, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ITextValue } from '../../../models/ITextValue';
import { FormGroup, FormControl } from '@angular/forms';
import { IReport, IReportPost } from '../../../models/IReport';
import { HttpService } from '../../../services/HttpService';
import { IProjectModel } from '../../../models/IProjectModel';
import * as _ from 'lodash';
import { IReportUser } from '../../../models/IReportUser';
import { Observable } from 'rxjs';
import { ToasterService } from 'angular2-toaster';
import { catchError } from 'rxjs/operators';
import { IUsedDayOff } from '../../../models/IDayOff';

@Component({
    selector: 'app-new-vacation-form',
    templateUrl: './new-vacation-form.component.html',
    styleUrls: ['./new-vacation-form.component.scss'],
    providers: [ToasterService],
})

@Injectable()
export class AppNewVacationFormComponent implements OnInit {
    selectedItem: ITextValue;
    modelValue: ITextValue;
    addDayOffForm: FormGroup;
    dayOffTypeCollection =
        [{ text: 'Vacation', value: 'Vacation' },
        { text: 'Sickness', value: 'Sickness' }];

    constructor(private http: HttpService) {
    }

    @Output() cancel: EventEmitter<void> = new EventEmitter();
    @Output() saved: EventEmitter<IUsedDayOff> = new EventEmitter();
    @Input() dayOffType: string;

    onCancelClick () {
        this.cancel.emit();
    }

    addDayOffSubmitForm($event, form) {
        form.submitted = true;

        if (!form.valid) {
            return;
        }

        const dayOff: IUsedDayOff = {
            from: form.value.range[0],
            to: form.value.range[1],
            wholeDay: form.value.wholeDay,
            unpaid: form.value.unpaid,
            dayOffType: form.value.dayOffType
        };

        this.saved.emit(dayOff);
    }

    ngOnInit(): void {
        const nowDate = new Date();
        nowDate.setUTCHours(0, 0, 0, 0);

        this.addDayOffForm = new FormGroup({
            range: new FormControl(),
            dayOffType: new FormControl(this.dayOffType),
            unpaid: new FormControl(false),
            wholeDay: new FormControl('true')
        });
    }
}

